// Archivo: src/pages/home-landing/Index.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import HeroBanner from './components/HeroBanner';
import ProgressSection from './components/ProgressSection';
import RaffleInfoSection from './components/RaffleInfoSection';
// import WhatsAppFloat from './components/WhatsAppFloat'; // ❌ ELIMINADO
import FooterSection from './components/FooterSection';
import UserAuthIndicator from '../../components/ui/UserAuthIndicator';
import PaymentStatusNotification from '../../components/ui/PaymentStatusNotification';

// Importamos la conexión de Supabase para centralizar la carga de datos
import { supabase } from '../../supabaseClient'; 

const HomeLanding = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [paymentNotification, setPaymentNotification] = useState(null);
  const [isRaffleActive, setIsRaffleActive] = useState(true);

  // ***************************************************************
  // Lógica de carga de datos CENTRALIZADA para toda la Home Page
  // ***************************************************************
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Handlers (Se mantienen tus handlers originales)
  const handlePurchaseClick = () => {
    if (!isRaffleActive) {
      alert('El sorteo ha finalizado. ¡Mantente atento a nuestro próximo sorteo!');
      return;
    }
    navigate('/purchase-flow');
  };

  const handleVerifyTicket = () => { navigate('/ticket-verification'); };
  const handleContactClick = () => { navigate('/contact'); };
  const handleLogin = () => { /* ... lógica de login ... */ };
  const handleLogout = () => { /* ... lógica de logout ... */ };
  const handleProfileClick = () => { navigate('/profile'); };
  const handleNotificationDismiss = () => { setPaymentNotification(null); };
  const handleNotificationViewDetails = (notification) => {
    if (notification?.type === 'success') {
      navigate('/payment-confirmation');
    } else {
      navigate('/purchase-flow');
    }
  };

  // EFECTO PRINCIPAL: Carga de Datos y Chequeo de Estado
  useEffect(() => {
    // 1. Carga de Datos de Supabase
    async function fetchRaffleDetails() {
      // Usamos todos los campos que necesitan HeroBanner y RaffleInfoSection
      const { data, error } = await supabase
        .from('raffles') // ✅ CORREGIDO: Cambiado de 'Sorteos' a 'raffles'
        .select('titulo, fecha_sorteo, precio_boleto, boletos_totales, premio_principal, premio_secundario, premio_tercero, imagen_url, boletos_vendidos, estado')
        .eq('estado', 'activo')
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('🔴 Error Supabase en HomeLanding (Index):', error.message);
        setError("Error de conexión con la base de datos.");
      } else if (data) {
        // Si hay data, verificamos si el sorteo aún está activo (basado en la fecha)
        const raffleEndDate = new Date(data.fecha_sorteo);
        const now = new Date();
        setIsRaffleActive(now < raffleEndDate);
      } else {
        // No se encontró sorteo activo (PGRST116)
        setError("No se encontró un sorteo activo.");
        setIsRaffleActive(false);
      }
      setLoading(false);
    }
    
    // 2. Lógica de Autenticación y Notificaciones (Tu lógica original)
    const savedUser = localStorage.getItem('aurea_user');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (error) {
        console.error('Error parsing saved user:', error);
        localStorage.removeItem('aurea_user');
      }
    }
    const paymentStatus = localStorage.getItem('payment_status');
    if (paymentStatus) {
      try {
        const status = JSON.parse(paymentStatus);
        setPaymentNotification(status);
        setTimeout(() => {
          localStorage.removeItem('payment_status');
        }, 1000);
      } catch (error) {
        console.error('Error parsing payment status:', error);
        localStorage.removeItem('aurea_user');
        localStorage.removeItem('payment_status');
      }
    }
    
    // Ejecutar la carga de Supabase
    fetchRaffleDetails();

  }, []);
  
  // Manejo de carga global para evitar saltos
  if (loading) {
      return (
          <div className="min-h-screen flex items-center justify-center bg-background">
              <p className="text-2xl text-secondary animate-pulse">Cargando Sorteo...</p>
          </div>
      );
  }

  // Manejo de error si no se encuentra sorteo o hay error de conexión
  if (error) {
      return (
          <div className="min-h-screen flex flex-col items-center justify-center bg-background">
              <Header />
              <div className="bg-card border border-error/50 p-8 rounded-xl text-center max-w-lg mt-20">
                  <h2 className="text-2xl font-heading font-bold text-error mb-4">⚠️ {error}</h2>
                  <p className="text-muted-foreground font-body">Por favor, asegúrate de que exista una fila en la tabla 'raffles' con el campo 'estado' igual a 'activo'.</p>
              </div>
          </div>
      );
  }


  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Payment Status Notifications */}
      <PaymentStatusNotification
        paymentStatus={paymentNotification}
        onDismiss={handleNotificationDismiss}
        onViewDetails={handleNotificationViewDetails}
      />

      {/* Main Content */}
      <main className="relative">
        
        {/* Hero Banner Section */}
        <HeroBanner 
          key={Date.now()} // FUERZA RERENDER
          onPurchaseClick={handlePurchaseClick}
          isRaffleActive={isRaffleActive}
        />

        {/* Progress Section */}
        <ProgressSection />

        {/* Raffle Information Section */}
        <RaffleInfoSection 
          onVerifyTicket={handleVerifyTicket}
          onContactClick={handleContactClick}
        />

        {/* --- SECCIÓN OCULTA TEMPORALMENTE --- */}
        {/* 
        <Gallery />
        */}
        
        {/* Próximamente: Galería de Ganadores */}
        <section className="py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full mb-6 shadow-lg animate-pulse">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4">
                PRÓXIMAMENTE
              </h2>
              <h3 className="text-2xl md:text-3xl font-heading font-semibold text-yellow-400 mb-4">
                GALERÍA DE GANADORES
              </h3>
              <p className="text-lg text-slate-300 font-body max-w-2xl mx-auto">
                Estamos preparando una experiencia increíble para que puedas conocer las historias de nuestros ganadores y revivir la emoción de nuestros sorteos anteriores.
              </p>
              <div className="mt-8 flex items-center justify-center space-x-4">
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              </div>
            </div>
          </div>
        </section>
        {/* --- FIN SECCIÓN PRÓXIMAMENTE --- */}

        {/* Footer Section */}
        <FooterSection />
      </main>

      {/* ❌ WHATSAPP FLOAT ELIMINADO */}
      
      {/* User Authentication Indicator (Hidden on mobile, shown in header) */}
      <div className="hidden">
        <UserAuthIndicator
          user={user}
          onLogin={handleLogin}
          onLogout={handleLogout}
          onProfileClick={handleProfileClick}
          showNotifications={true}
        />
      </div>
    </div>
  );
};

export default HomeLanding;